import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import DSSeparator from '@elliemae/ds-basic/Separator';
import DSButton from '@elliemae/ds-basic/Button';
import styled from 'styled-components';
import { get } from '@elliemae/ds-utilities/utils';
import deferComponentRender from '@elliemae/ds-shared/defer-render-hoc';
import useDataGrid from '@elliemae/ds-shared/useDataGrid';
import { PaginationPlugin } from '../pagination/PaginationPlugin.js';
import BodyCell from '../../components/BodyCell.js';
import { d as defaultRenderers } from '../../index-4a6329dc.js';
import TableBody from '../../components/TableBody.js';
import Table from '../../components/Table.js';
import { ColumnSizingPlugin } from '../column-sizing/ColumnSizingPlugin.js';
import '@babel/runtime/helpers/esm/extends';
import '@elliemae/ds-utilities/system';
import '@elliemae/ds-shared/FocusGroup/FocusGrid';
import '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import '../pagination/helper.js';
import '../pagination/usePaginationState.js';
import '@babel/runtime/helpers/esm/slicedToArray';
import '@elliemae/ds-utilities/hooks/useDerivedStateFromProps';
import '../../components/NoResults.js';
import '@elliemae/ds-system';
import '@babel/runtime/helpers/esm/toConsumableArray';
import 'prop-types';
import '@elliemae/ds-shared/createDataInstance/utils';
import '@elliemae/ds-basic/TruncatedTooltipText';
import '../../components/renderers/defaultClassedRenderers.js';
import '@elliemae/ds-classnames';
import '../../blockNames.js';
import '../../components/renderers/renderRowsLoader.js';
import '../../components/RowsLoader.js';
import '@elliemae/ds-basic/Spinner';
import '../../components/tableContext.js';
import '../../components/TableHeader.js';
import '../../components/HeaderCell.js';
import '../column-sizing/useStylesheetHelpers.js';
import 'stylesheet-helpers';
import '../column-sizing/getColumnNameFromProperty.js';
import '../../utilities/getScrollbarSize.js';
import '../column-sizing/useColumnSizeService.js';
import '../column-sizing/utils.js';
import '../column-sizing/ext-points/getTableProps.js';
import '@elliemae/ds-utilities/hooks/useResizeObserver';
import '../column-sizing/ext-points/decorateColumn.js';
import '../column-sizing/columnMeasurerTransformer.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var DetailGrid = deferComponentRender(function (_ref) {
  var parentGrid = _ref.parentGrid,
      parentRowData = _ref.parentRowData,
      rows = _ref.rows;

  var _parentGrid$props = parentGrid.props;
      _parentGrid$props.instanceRef;
      var parentProps = _objectWithoutProperties(_parentGrid$props, ["instanceRef"]);

  var grid = useDataGrid(_objectSpread(_objectSpread({
    uuid: parentGrid.getInstance().uuid
  }, parentProps), {}, {
    columns: parentGrid.getInstance().decoratedColumns.filter(function (col) {
      return !col.expandableColumn;
    }).map(function (c) {
      return _objectSpread(_objectSpread({}, c), {}, {
        expandableColumn: false
      });
    }),
    rows: rows,
    plugins: [ColumnSizingPlugin, PaginationPlugin],
    renderers: defaultRenderers,
    bindColumnsSizeTo: parentGrid.uuid,
    numRowsVisible: 'all',
    paginated: true,
    pagination: {
      perPage: rows.length,
      conditionalPagination: true
    },
    parentRowData: parentRowData
  }));
  return /*#__PURE__*/React.createElement(Table, grid, /*#__PURE__*/React.createElement(TableBody, null));
}, null);
var DetailsWrapper = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1goa4zy-0"
})(["flex:1;width:", "px;"], function (props) {
  return props.width;
});
var DetailGridWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1goa4zy-1"
})(["display:flex;height:calc(100% - ", "px);width:", "px;margin:12px 0;"], function (props) {
  return props.allRowsVisible ? 18 : 60;
}, function (props) {
  return props.expandableGridDetailWidth;
});

function ExpandedRow(_ref2) {
  var parentGrid = _ref2.parentGrid,
      detailColumns = _ref2.detailColumns,
      rowData = _ref2.rowData,
      rows = _ref2.rows,
      rowProps = _ref2.rowProps,
      CellComponent = _ref2.cellComponent,
      RowComponent = _ref2.rowComponent;

  var _parentGrid$getInstan = parentGrid.getInstance(),
      decoratedColumns = _parentGrid$getInstan.decoratedColumns,
      toggleShowAllRows = _parentGrid$getInstan.actions.toggleShowAllRows,
      expandedRows = _parentGrid$getInstan.state.expandedRows,
      _parentGrid$getInstan2 = _parentGrid$getInstan.props,
      rowKey = _parentGrid$getInstan2.rowKey,
      _parentGrid$getInstan3 = _parentGrid$getInstan2.showMoreRowsText,
      showMoreRowsText = _parentGrid$getInstan3 === void 0 ? 'SHOW ALL ROWS' : _parentGrid$getInstan3,
      _parentGrid$getInstan4 = _parentGrid$getInstan2.showLessRowsText,
      showLessRowsText = _parentGrid$getInstan4 === void 0 ? 'SHOW LESS ROWS' : _parentGrid$getInstan4,
      expandableSubrowsVisible = _parentGrid$getInstan2.expandableSubrowsVisible,
      expandableGridDetailWidth = _parentGrid$getInstan.columnSizeService.expandableGridDetailWidth;

  var showAllRows = rowProps.showAllRows,
      restRowProps = _objectWithoutProperties(rowProps, ["showAllRows"]);

  return /*#__PURE__*/React.createElement(RowComponent, restRowProps, /*#__PURE__*/React.createElement(BodyCell, {
    column: decoratedColumns[0],
    columnIndex: 0,
    component: CellComponent,
    grid: parentGrid,
    rowProps: _objectSpread({
      rowData: rowData
    }, rowProps)
  }), /*#__PURE__*/React.createElement(DetailsWrapper, {
    width: expandableGridDetailWidth
  }, /*#__PURE__*/React.createElement(DetailGridWrapper, {
    allRowsVisible: rows.length < expandableSubrowsVisible || get(expandedRows, [rowKey, 'showAllRows']),
    expandableGridDetailWidth: expandableGridDetailWidth
  }, /*#__PURE__*/React.createElement(DSSeparator, {
    dashed: true,
    orientation: "vertical"
  }), /*#__PURE__*/React.createElement(DetailGrid, {
    detailColumns: detailColumns,
    parentGrid: parentGrid.getInstance(),
    parentRowData: rowData,
    rows: showAllRows ? rows : (rows || []).slice(0, expandableSubrowsVisible)
  })), rows.length > expandableSubrowsVisible && /*#__PURE__*/React.createElement(DSButton, {
    buttonType: "text",
    labelText: showAllRows ? showLessRowsText : showMoreRowsText,
    onClick: function onClick(e) {
      e.stopPropagation();
      toggleShowAllRows(rowData);
    },
    style: {
      marginBottom: '10px'
    }
  })));
}

export default ExpandedRow;
//# sourceMappingURL=ExpandedRow.js.map
